"use client";

import { Skeleton } from "@heroui/skeleton";

export function UserStatsSkeleton() {
  return (
    <div className="w-full py-8 md:py-12">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-8 lg:px-12">
        {/* Greeting with Avatar */}
        <div className="flex items-start gap-3 mb-6">
          <Skeleton className="rounded-full w-12 h-12 flex-shrink-0" />
          <div className="flex-1">
            <Skeleton className="rounded-lg w-64 h-8 mb-2" />
            <Skeleton className="rounded-lg w-80 h-5" />
          </div>
        </div>

        {/* Stats Grid - 4 columns */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6">
          {/* Stat Card 1 */}
          <div className="relative p-6 rounded-2xl bg-neutral-800/50">
            <Skeleton className="rounded-lg w-24 h-10 mb-3" />
            <Skeleton className="rounded-lg w-28 h-5" />
          </div>

          {/* Stat Card 2 */}
          <div className="relative p-6 rounded-2xl bg-neutral-800/50">
            <Skeleton className="rounded-lg w-20 h-10 mb-3" />
            <Skeleton className="rounded-lg w-32 h-5" />
          </div>

          {/* Stat Card 3 */}
          <div className="relative p-6 rounded-2xl bg-neutral-800/50">
            <Skeleton className="rounded-lg w-24 h-10 mb-3" />
            <Skeleton className="rounded-lg w-32 h-5" />
          </div>

          {/* Stat Card 4 */}
          <div className="relative p-6 rounded-2xl bg-neutral-800/50">
            <Skeleton className="rounded-lg w-16 h-10 mb-3" />
            <Skeleton className="rounded-lg w-24 h-5" />
          </div>
        </div>
      </div>
    </div>
  );
}
